export const siteName = '楽ポグラフ';